import { Visibility, VisibilityOff } from '@mui/icons-material'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface Props {
  showHiddenSteps: boolean
  onToggleHiddenSteps: () => void
  onClose?: () => void
}

export const ToggleHiddenStepsMenuItem = ({ showHiddenSteps, onToggleHiddenSteps, onClose }: Props) => {
  const { t } = useTranslation('requests')

  const showText = t('manage-request.show-hidden-steps')
  const hideText = t('manage-request.hide-hidden-steps')

  const handleClick = () => {
    onToggleHiddenSteps()
    onClose?.()
  }

  return (
    <MenuItem onClick={handleClick}>
      <ListItemIcon>{showHiddenSteps ? <VisibilityOff /> : <Visibility />}</ListItemIcon>
      <ListItemText
        sx={{
          '& .MuiListItemText-primary': {
            display: 'grid',
            '& > span': { gridArea: '1 / 1', whiteSpace: 'nowrap' },
          },
        }}
      >
        {/* Render both texts in same grid area to maintain consistent width */}
        <span style={{ visibility: showHiddenSteps ? 'hidden' : 'inherit' }}>{showText}</span>
        <span style={{ visibility: showHiddenSteps ? 'inherit' : 'hidden' }}>{hideText}</span>
      </ListItemText>
    </MenuItem>
  )
}
